import { InputAdornment, SxProps, TextField, Theme } from '@mui/material';
import React, { useState } from 'react'
import { IsEmpty } from '../Helpers';
import SearchIcon from '@mui/icons-material/Search';
import { I18N } from '../I18N';

export interface SearchProps
{
    onChange: (newValue: string) => void;
    style?: object;
    size?: 'medium' | 'small';
    placeholder?: string;
    loading?: boolean;
    delay?: number;
    inSearchText?: string;
    sx?: SxProps<Theme>;
}

const SearchBox = ({ onChange, size = 'small', style = {}, sx = {}, inSearchText = '', placeholder = I18N.Translate('placeholder_Search'), loading = false, delay = 400 } : SearchProps) => {
    const [timer, setTimer] = useState<NodeJS.Timer>(null);
    const [searchText, setSearchText] = useState<string>(inSearchText);

    const searchTextChanged = (value: string) => {
        setSearchText(value);        
        clearTimeout(timer);
        setTimer(setTimeout(() => onChange(value), delay));
    };

    return (
        <TextField size={size} variant="outlined"
            disabled={loading} 
            style={style} 
            sx={{
                width: { xs: '100%', sm: 'auto' },
                minWidth: { sm: 220 },
                '& .MuiInputBase-root': { minHeight: 44 },
                ...sx,
            }}
            type="search"
            label={placeholder} 
            InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )}} 
            value={searchText}
            onChange={(e) => searchTextChanged(e.target.value)}  />
    );
}

const AnyPropContains = (inObj: any, value: string) => {
    return Object.getOwnPropertyNames(inObj).filter(x => `${inObj[x]}`?.toLowerCase().includes(value.toLowerCase())).length > 0;
}

export const SearchBox_AnyPropFilter = (inObjList: any[], searchText: string) => {
    return IsEmpty(searchText) ? inObjList : inObjList?.filter(x => AnyPropContains(x, searchText));
}

export const useSearchBox: () => [() => JSX.Element, (inObjList: any[]) => any[]] = () => {
    const [searchText, setSearchText] = useState<string>();
    return [() => <>{SearchBox({onChange: setSearchText, inSearchText: searchText})}</>, (inObjList: any[]) => SearchBox_AnyPropFilter(inObjList, searchText)];
}

export default SearchBox;
